export default __webpack_public_path__ + "static/media/comm-2.df0058ab.png";